jQuery(
	function($) {
		// Download button.
		$( '.podcast-meta-download' )
		.addClass( 'button' )
		.prepend( '<span class="dashicons dashicons-download"></span> ' );

		// New window button.
		$( '.podcast-meta-new-window' )
		.addClass( 'button' )
		.prepend( '<span class="dashicons dashicons-external"></span> ' );

		// Duration button.
		$( '.podcast-meta-duration' )
		.addClass( 'button' )
		.prepend( '<span class="dashicons dashicons-clock"></span> ' );
	}
);
